import * as React from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import { ExpandMoreIcon } from 'mdi-react';
import classNames from 'classnames';
import _ from 'lodash';

import Iconized from './Iconized';
import GridNoPadding from './GridNoPadding';

type Props = {
  children: React.Node,
  classes: any,
  className?: string,
  label?: string,
  labelProps?: Object,
  textProps?: Object,
  icon?: any,
  expandButton?: boolean,
  expanded?: boolean,
  onExpandClick?: any => void
};

const LabeledText = ({
  //$FlowFixMe
  children = <span />,
  classes,
  className,
  label,
  labelProps = {},
  textProps = {},
  icon,
  expandButton = false,
  expanded,
  onExpandClick,
  ...otherProps
}: Props) => {
  return (
    <div
      className={classNames(classes.root, className, {
        [classes.clickable]: _.isFunction(onExpandClick) && expandButton
      })}
      onClick={event => {
        onExpandClick && onExpandClick(event);
      }}
      {...otherProps}
    >
      <Iconized icon={icon} alignItems="center">
        <GridNoPadding container spacing={0} alignItems="center">
          <GridNoPadding item xs>
            {_.isString(label) && (
              <Typography variant="caption" {...labelProps}>
                {label}
              </Typography>
            )}
            <Typography variant="subheading" {...textProps}>
              {children} &nbsp;
            </Typography>
          </GridNoPadding>
          {expandButton ? (
            <GridNoPadding item>
              <ExpandMoreIcon
                className={classNames(classes.expand, {
                  [classes.expandOpen]: expanded
                })}
              />
            </GridNoPadding>
          ) : null}
        </GridNoPadding>
      </Iconized>
    </div>
  );
};

const styles = ({
  //spacing: { unit: spacing },
  //palette: { primary: primaryColorInfo },
  transitions,
  breakpoints
}) => ({
  root: {},
  expand: {
    transform: 'rotate(0deg)',
    transition: transitions.create('transform', {
      duration: transitions.duration.shortest
    }),
    marginLeft: 'auto',
    [breakpoints.up('sm')]: {
      marginRight: -8
    }
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  clickable: {
    cursor: 'pointer'
  }
});

export default withStyles(styles)(LabeledText);
